import { laptopSmallMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

const tablet = 'max-width: 767px';

export const Container = styled.div<{ $wideDisplay?: boolean }>`
  padding: 7px 7px 7px 15px;
  border-radius: 8px;
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: row;
  gap: 15px;
  border: 1px solid ${({ theme }) => theme.backgroundLight};

  svg {
    font-size: 24px;
  }

  @media (${laptopSmallMax}) {
    padding: 12px;
  }

  @media (${tablet}) {
    gap: 15px;
    flex-direction: column;
    text-align: center;

    svg {
      font-size: 34px;
    }
  }
`;

export const TextBox = styled.p`
  flex: 1;
  text-align: left;
  font-weight: bold;
  font-size: 18px;
  color: ${({ theme }) => theme.textDark};

  span {
    font-weight: normal;
  }

  @media (${tablet}) {
    text-align: center;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  max-width: 260px;
  margin: 0 auto;
`;
